export default {

  
    welcome: "مرحبا",
      search_placeholder: "ابحث عن المنتجات أو الطلبات...",
      profile: "الملف الشخصي",
      logout: "تسجيل خروج",

      my_products: "منتجاتي",
      add_product: "إضافة منتج جديد",   // 🔥 fixed (was missing "new")
      offers: "العروض",
      orders: "الطلبات",
      credit_wallet: "محفظة الائتمان",  // 🔥 better than "المحفظة"
      invoice: "نموذج الفاتورة",        // 🔥 matches "Invoice Form"
      receipts: "مدير الإيصالات",        // 🔥 matches "Receipt Manager"
      reports: "التقارير",
      issues: "مشاكل الطلبات",
      delivery: "مندوبي التوصيل",       // 🔥 better than "المندوبين"
      promotion_review: "مراجعة العروض الترويجية", // 🔥 more accurate
      paid_promotion: "العروض الترويجية المدفوعة", // 🔥 better meaning
      support: "الدعم",
      documentation: "التوثيق",
      help: "المساعدة",
}